import {
  AddMultipleCandidatesToPositionErrorOutput,
  AddMultipleCandidatesToPositionInput,
  CandidateBuilder,
} from '../candidates.types';

export const addMultipleCandidateToPosition = (builder: CandidateBuilder) =>
  builder.mutation<
    any | AddMultipleCandidatesToPositionErrorOutput,
    AddMultipleCandidatesToPositionInput
  >({
    queryFn: async (args, api, extraOptions, baseQuery) => {
      const results = await Promise.all(
        args.candidateIds.map(async (singleCandidateId) => {
          const response = await baseQuery({
            url: '/candidate-position-status/add-candidate',
            method: 'POST',
            body: {
              candidateId: singleCandidateId,
              positionId: args.positionId,
            },
          });
          return { ...response, candidateId: singleCandidateId };
        })
      );

      const { success, error } = results.reduce(
        (prev, act) => {
          if (act.error) {
            prev.error.push({ ...act.error, candidateId: act.candidateId });
          } else if (act.data) {
            prev.success.push(act.data);
          }
          return prev;
        },
        {
          error: [] as any[],
          success: [] as unknown[],
        }
      );

      if (error.length > 0) {
        return {
          error: {
            status: 500,
            statusText: 'Internal Server Error',
            data: error,
          },
        };
      }

      return { data: success };
    },
    invalidatesTags: () => [{ type: 'Candidates' }],
  });
